const GOOGLE_ADS_TAG_ID = 'AW-11359561325'

type GoogleTagParameterValue = boolean | number | string | undefined

type GoogleTagParameters = Record<string, GoogleTagParameterValue>

type GoogleTagFunction = (...arguments_: unknown[]) => void

declare global {
  interface Window {
    gtag?: GoogleTagFunction
  }
}

const getGoogleTag = (): GoogleTagFunction | undefined => {
  if (typeof window === 'undefined') return undefined

  return window.gtag
}

const isGoogleTagEnabled = (): boolean =>
  process.env.NODE_ENV === 'production' && typeof window !== 'undefined'

export const trackGoogleTagEvent = (
  eventName: string,
  parameters: GoogleTagParameters = {},
): void => {
  if (!isGoogleTagEnabled()) return

  getGoogleTag()?.('event', eventName, parameters)
}

export const trackGoogleTagPageView = (pathname: string): void => {
  trackGoogleTagEvent('page_view', {
    page_location: window.location.href,
    page_path: pathname,
    page_title: document.title,
  })
}

export const trackGoogleAdsConversion = (
  conversionLabel: string,
  parameters: GoogleTagParameters = {},
): void => {
  trackGoogleTagEvent('conversion', {
    ...parameters,
    send_to: `${GOOGLE_ADS_TAG_ID}/${conversionLabel}`,
  })
}
